import React, { useContext } from 'react'

import { LeadTemplatesStoreContext } from '../../contexts'
import { LeadTemplatesStore } from '../../types'

const useLeadTemplatesStore = (): LeadTemplatesStore => {
   const leadTemplatesStore = useContext(LeadTemplatesStoreContext)

   if (!leadTemplatesStore) {
      throw new Error('Expected to be wrapped in Lead Template Store Provider')
   }

   return leadTemplatesStore
}

export { useLeadTemplatesStore }
